import { companySlice } from './slice'

export const {
  // Company Details
  setCompanyDetailsLoading,
  setCompanyDetailsData,
  resetCompanyDetailState,
  // Edit Company Details
  setEditCompanyLoading,
  setEditCompanySuccess,
  resetEditCompanyState,
  setEditCompanyError
} = companySlice.actions

